frappe.desktop_utils = {};
frappe.desktop_grids = [];
frappe.desktop_icons_objects = [];

function get_route(desktop_icon) {
	let route;
	if (!desktop_icon) return;
	let item = {};
	if (desktop_icon.link_type == "External" && desktop_icon.link) {
		route = window.location.origin + desktop_icon.link;
	} else {
		let sidebar = frappe.boot.workspace_sidebar_item[desktop_icon.label.toLowerCase()];
		if (desktop_icon.link_type == "Workspace Sidebar" && sidebar) {
			let first_link = sidebar.items.find((i) => i.type == "Link");
			if (first_link) {
				if (first_link.link_type === "Report") {
					let args = {
						type: first_link.link_type,
						name: first_link.link_to,
					};

					if (first_link.report || !frappe.app.sidebar.editor.edit_mode) {
						args.is_query_report =
							first_link.report.report_type === "Query Report" ||
							first_link.report.report_type == "Script Report";
						args.report_ref_doctype = first_link.report.ref_doctype;
					}

					route = frappe.utils.generate_route(args);
				} else if (first_link.link_type == "Workspace") {
					let workspaces = frappe.workspaces[frappe.router.slug(first_link.link_to)];
					if (workspaces) {
						if (workspaces.public) {
							route = "/desk/" + frappe.router.slug(first_link.link_to);
						} else {
							route = "/desk/private/" + frappe.router.slug(workspaces.title);
						}
					}

					if (first_link.route) {
						route = first_link.route;
					}
				} else if (first_link.link_type === "URL") {
					route = first_link.url;
				} else if (first_link.link_type == "Page" && first_link.route_options) {
					route = frappe.utils.generate_route({
						type: first_link.link_type,
						name: first_link.link_to,
						route_options: JSON.parse(first_link.route_options),
					});
				} else {
					route = frappe.utils.generate_route({
						type: first_link.link_type,
						name: first_link.link_to,
						tab: first_link.tab,
					});
				}
			}
		}
	}
	return route;
}

export class DesktopLauncher {
	constructor(wrapper) {
		this.wrapper = $(wrapper);
		this.ensure_desktop_icons();
		this.prepare();
		this.make();
	}

	ensure_desktop_icons() {
		// Ensure frappe.boot.desktop_icons exists
		if (!frappe.boot.desktop_icons) {
			frappe.boot.desktop_icons = [];
			console.warn("frappe.boot.desktop_icons not found, using empty array");
		}
		if (!frappe.boot.workspace_sidebar_item) {
			frappe.boot.workspace_sidebar_item = {};
			console.warn("frappe.boot.workspace_sidebar_item not found, using empty object");
		}
	}

	update() {
		this.prepare();
		this.make();
	}

	prepare() {
		this.apps_icons = [];

		const icon_map = {};
		frappe.desktop_icons = frappe.boot.desktop_icons;
		let icons = frappe.desktop_icons;
		const all_icons = icons.filter((icon) => {
			if (icon.hidden != 1) {
				icon.child_icons = [];
				icon_map[icon.label] = icon;
				return true;
			}
			return false;
		});
		all_icons.forEach((icon) => {
			if (icon.parent_icon && icon_map[icon.parent_icon]) {
				icon_map[icon.parent_icon].child_icons.push(icon);
			}

			if (!icon.parent_icon || !icon_map[icon.parent_icon]) {
				this.apps_icons.push(icon);
			}
		});
	}

	make() {
		this.wrapper.empty();
		$(`<div class="desktop-modal-wrapper">
			<div class="desktop-modal-desktop-wrapper">
				<div class="desktop-modal-desktop-container">
				</div>
			</div>
			<div class="desktop-shortcut-legend"></div>
		</div>`).appendTo(this.wrapper);

		this.container = this.wrapper.find(".desktop-modal-desktop-container");
		this.container.data("desktop_page", this);
		this.show_main_grid();
	}

	show_main_grid() {
		this.container.empty();
		this.icon_grid = new DesktopIconGrid({
			wrapper: this.container,
			icons_data: this.apps_icons,
			desktop_page: this,
		});
	}
}

class DesktopIconGrid {
	constructor(opts) {
		$.extend(this, opts);
		this.icons = [];
		this.icons_html = [];
		this.grids = [];

		if (!this.desktop_page) {
			this.desktop_page = this.wrapper.data("desktop_page");
		}

		this.prepare();
		this.make();
		frappe.desktop_grids.push(this);
	}

	prepare() {
		this.icons_data = this.icons_data.sort((a, b) => {
			return __(a.label).localeCompare(__(b.label)); // @dokos: only sort by label not by idx
		});

		const page_size = 24; // 6x4 grid
		this.total_pages = Math.ceil(this.icons_data.length / page_size) || 1;
		this.icons_data_by_page = [];
		for (let i = 0; i < this.total_pages; i++) {
			this.icons_data_by_page.push(
				this.icons_data.slice(i * page_size, (i + 1) * page_size)
			);
		}
	}

	make() {
		if (this.in_folder) {
			this.add_back_button();
		}

		this.icons_container = $(`<div class="desktop-modal-icons-container"></div>`).appendTo(
			this.wrapper
		);

		for (let i = 0; i < this.total_pages; i++) {
			let template = `<div class="desktop-modal-icons"></div>`;

			if (this.row_size) {
				template = `<div class="desktop-modal-icons" style="grid-template-columns: repeat(${this.row_size}, 1fr)"></div>`;
			}
			this.grids.push($(template).appendTo(this.icons_container));
			this.make_icons(this.icons_data_by_page[i], this.grids[i]);
		}

		if (this.total_pages > 1) {
			this.add_page_indicators();
			this.add_nav_arrows();
			this.setup_pagination();
			this.setup_swipe_gesture();
		} else {
			this.grids[0] && this.grids[0].css("display", "grid");
		}
	}

	setup_swipe_gesture() {
		const me = this;
		this.grids.forEach((grid) => {
			$(grid).on("wheel", function (event) {
				if (event.originalEvent) {
					event = event.originalEvent;
				}

				if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
					event.preventDefault();
					if (event.deltaX > 0) {
						if (me.current_page < me.total_pages - 1) {
							me.change_to_page(me.current_page + 1);
						}
					} else {
						if (me.current_page > 0) {
							me.change_to_page(me.current_page - 1);
						}
					}
				}
			});
		});
	}

	add_page_indicators() {
		this.page_indicators = [];
		this.pagination_indicator = $(`<div class='page-indicator-container'></div>`).appendTo(
			this.wrapper.parent()
		);
		for (let i = 0; i < this.total_pages; i++) {
			this.page_indicators.push(
				$("<div class='page-indicator'></div>").appendTo(this.pagination_indicator)
			);
		}
	}

	setup_pagination() {
		this.current_page = this.old_index = 0;
		this.change_to_page(this.current_page);
	}

	add_nav_arrows() {
		const me = this;

		this.btn_prev = $(
			`<div class="desktop-nav-arrow left-arrow">${frappe.utils.icon("left", "md")}</div>`
		).appendTo(this.wrapper.parent());
		this.btn_next = $(
			`<div class="desktop-nav-arrow right-arrow">${frappe.utils.icon("right", "md")}</div>`
		).appendTo(this.wrapper.parent());

		this.btn_prev.on("click", () => {
			if (me.current_page > 0) {
				me.change_to_page(me.current_page - 1);
			}
		});

		this.btn_next.on("click", () => {
			if (me.current_page < me.total_pages - 1) {
				me.change_to_page(me.current_page + 1);
			}
		});
	}

	change_to_page(index) {
		// Hide all grids
		this.grids.forEach((g) => $(g).css("display", "none"));

		// Show current grid
		this.grids[index].css("display", "grid");

		// Update page indicators
		if (this.page_indicators.length) {
			this.page_indicators[this.old_index].removeClass("active-page");
			this.page_indicators[index].addClass("active-page");
		}

		// Update arrow states
		if (this.btn_prev && this.btn_next) {
			this.btn_prev.toggleClass("disabled", index === 0);
			this.btn_next.toggleClass("disabled", index === this.total_pages - 1);
		}

		this.current_page = index;
		this.old_index = index;
	}

	make_icons(icons_data, grid) {
		icons_data.forEach((icon) => {
			let icon_obj = new DesktopIcon(icon);
			let icon_html = icon_obj.get_desktop_icon_html();
			if (icon_html) {
				this.icons.push(icon_obj);
				this.icons_html.push(icon_html);
				grid.append(icon_html);
			}
		});
	}

	add_back_button() {
		this.back_button = $(`<div class="desktop-back-button">
			${frappe.utils.icon("left", "md")}
		</div>`).prependTo(this.wrapper);

		this.back_button.on("click", () => {
			if (this.desktop_page) {
				this.desktop_page.show_main_grid();
			}
		});
	}
}

class DesktopIcon {
	constructor(icon) {
		this.icon_data = icon;
		this.icon_title = this.icon_data.label;
		this.icon_subtitle = "";
		this.icon_type = this.icon_data.icon_type;
		this.icon_data.in_folder = true;
		this.link_type = this.icon_data.link_type;
		if (this.icon_type != "Folder" && !this.icon_data.sidebar) {
			this.icon_route = get_route(this.icon_data);
		}
		if (this.icon_data.child_icons) {
			this.child_icons = this.get_child_icons_data();
		}
		let render = this.validate_icon();
		if (render) {
			this.icon = $(
				frappe.render_template("desktop_icon", {
					icon: this.icon_data,
					in_folder: false,
				})
			);
			this.icon_caption_area = $(this.icon.get(0).children[1]);
			this.setup_click();
			this.render_folder_thumbnail();
			frappe.desktop_icons_objects.push(this);
		}
	}

	validate_icon() {
		if (this.icon_data.label == "My Workspaces") {
			if (frappe.boot.workspace_sidebar_item["my workspaces"].items.length == 0)
				return false;
		}
		if (this.icon_type == "Folder") {
			if (this.icon_data.child_icons.length == 0) return false;
		}
		return true;
	}

	get_child_icons_data() {
		return this.icon_data.child_icons.sort((a, b) => a.idx - b.idx);
	}

	get_desktop_icon_html() {
		return this.icon;
	}

	setup_click() {
		const me = this;
		if (this.child_icons?.length && (this.icon_type == "App" || this.icon_type == "Folder")) {
			// Prevent default link behavior for folders
			$(this.icon).on("click", function (e) {
				e.preventDefault();

				// Get desktop_page from the wrapper
				const desktop_page = $(e.currentTarget)
					.closest(".desktop-modal-desktop-container")
					.data("desktop_page");

				if (desktop_page) {
					// Clear the entire container to replace with folder contents
					desktop_page.container.empty();
					// Create new grid with child icons
					new DesktopIconGrid({
						wrapper: desktop_page.container,
						icons_data: me.child_icons,
						in_folder: true,
						parent_icon: me,
						desktop_page: desktop_page,
					});
				}
			});
			// Remove href to prevent navigation
			this.icon.removeAttr("href");
			this.icon.css("cursor", "pointer");
		} else {
			this.icon.attr("href", this.icon_route);
		}
		if (this.icon_data.sidebar) {
			const me = this;
			this.icon.on("click", function (e) {
				if (me.icon_data.sidebar == "My Workspaces") {
					e.preventDefault();
					let sidebar_name = me.icon_data.sidebar.toLowerCase();
					if (frappe.boot.workspace_sidebar_item[sidebar_name].items.length == 0) {
						frappe.toast("No Private Workspaces for user");
					} else {
						let workspace_name =
							frappe.boot.workspace_sidebar_item[sidebar_name].items[0]["link_to"];
						frappe.set_route("Workspaces", "private", workspace_name);
					}
				}
			});
		}
	}

	render_folder_thumbnail() {
		let condition =
			frappe.boot.show_app_icons_as_folder &&
			this.icon_type == "App" &&
			this.child_icons.length > 0;
		if (this.icon_type == "Folder" || condition) {
			if (!this.folder_wrapper) this.folder_wrapper = this.icon.find(".icon-container");
			this.folder_wrapper.html("");
			new DesktopIconGrid({
				wrapper: this.folder_wrapper,
				icons_data: this.child_icons,
				row_size: 4,
				in_folder: true,
				no_dragging: true,
			});
			if (this.icon_type == "App") {
				this.folder_wrapper.addClass("folder-icon");
			}
		}
	}
}
